module.exports = __webpack_public_path__ + "img/ultimateq-tenant-logo.6b33c36d.png";